import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '@services/authentification.service';
import {User} from '@models/user';
import {OnboardingService} from '@services/onboarding.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
    isLogin = false;
    user: User;
    showHistoric = false;
    showApiDashboard = false;

    constructor(
        public authenticationService: AuthenticationService,
        public onboardingService: OnboardingService,
        public router: Router,
    ) {
    }

    ngOnInit() {
        this.isLogin = this.authenticationService.isLogin;
        this.user = this.authenticationService.currentUser;
        this.showHistoric = this.user.user_onboarding.show_historic == true || this.onboardingService.isOnboardingActivate() == false;
        this.showApiDashboard = this.user.api_plan != '' || this.user.api_ayg_credit > 0;
    }

    get isAdminSection(): boolean {
        return this.router.url.startsWith('/app/admin');
    }
}
